import React, { useState } from "react";
import ArrowDownSvg from "../../../assets/icon/svgJsx/ArrowDownSvg";
import ArrowUpSvg from "../../../assets/icon/svgJsx/ArrowTopSvg";

const Accordion = ({ label, children, className, openDefault = false }) => {
  const [isOpen, setIsOpen] = useState(openDefault);

  return (
    <div
      className={`accordion ${isOpen ? "" : "accordion-close"} ${
        className?.root ? className?.root : ""
      } `}
    >
      <div className={`accordion__label ${className?.label}`}>
        <div className="accordion__label__left">{label.leftPart}</div>
        <div className="accordion__label__right">
          {label.rightPart}

          {children && (
            <span
              className={`accordion__label__right__arrows ${
                isOpen
                  ? "accordion__label__right__arrows-arrowUp"
                  : "accordion__label__right__arrows-arrowDown"
              }`}
              onClick={() => {
                setIsOpen(!isOpen);
              }}
            >
              {isOpen ? <ArrowUpSvg /> : <ArrowDownSvg />}
            </span>
          )}
        </div>
      </div>
      {isOpen && children && (
        <div className={`accordion-children ${className?.children}`}>
          {children}
        </div>
      )}
    </div>
  );
};

export default Accordion;
